import { IAccessToken } from '@/store/models/auth.model';

import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';

import { get } from '@/services/FetchServices';
export class AuthService {
  static queryKey = 'Auth';
  static getAccessToken = async (authorizationCode: string): Promise<IAccessToken> => {
    try {
      const config = getStaticDashboardConfig();
      const form = new FormData();
      form.append('grant_type', 'authorization_code');
      form.append('client_id', config.api.oauth.clientId);
      form.append('code', decodeURIComponent(authorizationCode));
      form.append('redirect_uri', `${config.api.oauth.redirectUri}`);

      return await get(
        {
          url: config.api.oauth.path,
          method: 'POST',
          body: form,
          isStringify: false,
          protectedEndPoint: false,
          action: this.queryKey,
          userRole: 'CONFIG',
        },
        {
          shouldSkipEncryption: true,
          isSingle: true,
        },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static refreshAccessToken = async (refreshToken: string, credentials?: string): Promise<IAccessToken> => {
    try {
      const config = getStaticDashboardConfig();
      const auth2FaProps = credentials ? { credentials } : {};

      const body = new URLSearchParams({
        client_id: config.api.oauth.clientId,
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        ...auth2FaProps,
      });

      return await get(
        { url: config.api.oauth.path, method: 'POST', body, isStringify: false, protectedEndPoint: false },
        {
          shouldSkipEncryption: true,
          isSingle: true,
        },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
